import { Cursor } from '@/components/Cursor'
import { Layout } from '@/components/Layout'
import { SignLayout } from '@/components/Store/Sign/SignLayout'
import { SignUpPage } from '@/components/Store/Sign/SignUpPage'

import type { ReactElement } from 'react'

function SignUp(): ReactElement {
  return (
    <>
      <Cursor kind="black" />
      <Layout context="store">
        <SignLayout>
          <SignUpPage />
        </SignLayout>
      </Layout>
    </>
  )
}

export default SignUp
